import { Route, Routes } from 'react-router-dom';
import type { JSX } from 'react';
import { MainLayout } from '@/components/layout';
import AboutPage from '@/pages/AboutPage';
import AdminLoginPage from '@/pages/AdminLoginPage';
import BrandDetailsPage from '@/pages/BrandDetailsPage';
import BrandOfferDetailPage from '@/pages/BrandOfferDetailPage';
import BrandOffersPage from '@/pages/BrandOffersPage';
import CategoryPage from '@/pages/CategoryPage';
import CreateCurationPage from '@/pages/CreateCurationPage';
import CurationsPage from '@/pages/CurationsPage';
import CurationsPageV2 from '@/pages/CurationsPageV2';
import CuratorStorePage from '@/pages/CuratorStorePage';
import HomePage from '@/pages/HomePage';
import InternalCreateCurationPage from '@/pages/InternalCreateCurationPage';
import OrderPlacedPage from '@/pages/OrderPlacedPage';
import PolicyPage from '@/pages/PolicyPage';
import ProductDetailPage from '@/pages/ProductDetailPage';
import ProductDetailPageV2 from '@/pages/ProductDetailPageV2';
import ProductFeedPage from '@/pages/ProductFeedPage';
import SearchPage from '@/pages/SearchPage';
import SearchSuggestionPage from '@/pages/SearchSuggestionPage';
import SelectFrame from '@/pages/SelectFrame';
import SimilarProductsPage from '@/pages/SimilarProductsPage';
import SlaylistPage from '@/pages/SlaylistPage';
import SlaylistView from '@/pages/SlaylistView';
import UploadPage from '@/pages/UploadPage';
import ApprovalPortalPage from '@/pages/ApprovalPortalPage';
import { AdminRoutes } from './AdminRoutes';

export default function AppRoutes(): JSX.Element {
  return (
    <Routes>
      <Route element={<MainLayout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/search" element={<SearchPage />} />
        <Route path="/similar-product" element={<SimilarProductsPage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/product/v2/:id" element={<ProductDetailPageV2 />} />
        <Route path="/upload" element={<UploadPage />} />
        <Route path="/curations/:id" element={<CurationsPage />} />
        <Route path="/curations/v2/:id" element={<CurationsPageV2 />} />
        <Route path="/curator-store" element={<CuratorStorePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/privacy-policy" element={<PolicyPage />} />
        <Route path="/search-suggestion" element={<SearchSuggestionPage />} />
        <Route path="/create-curations" element={<CreateCurationPage />} />
        <Route path="/edit-curations/:id" element={<CreateCurationPage />} />
        <Route path="/slaylist">
          <Route index element={<SlaylistPage />} />
          <Route path=":id" element={<SlaylistView />} />
        </Route>
        <Route path="/category/:id" element={<CategoryPage />} />
        <Route
          path="/internal/create-curation"
          element={<InternalCreateCurationPage />}
        />
        <Route path="/internal/feed" element={<ProductFeedPage />} />
        <Route path="/order-placed" element={<OrderPlacedPage />} />
        {/* Add more routes as needed */}
      </Route>
      <Route path="/select-frame" element={<SelectFrame />} />
      <Route path="/login" element={<AdminLoginPage />} />
      <Route element={<AdminRoutes />}>
        <Route path="/brand-offers" element={<BrandOffersPage />} />
        <Route path="/brand-offer/:id" element={<BrandOfferDetailPage />} />
        <Route path="/brand-details" element={<BrandDetailsPage />} />
        <Route path="/posts-approve" element={<ApprovalPortalPage />} />
        <Route path="/posts-approve/:id" element={<ApprovalPortalPage />} />
      </Route>
    </Routes>
  );
}
